import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, FeaturesConfigModule, I18nModule, UrlModule, provideDefaultConfig } from '@spartacus/core';
import {
  IconModule,
  ItemCounterModule,
  KeyboardFocusModule,
  PromotionsModule,
  SpinnerModule
} from '@spartacus/storefront';
import { CustomIconsModule } from '../../../../../../custom/icons/custom-icons.module';
import { CustomCartSharedModule } from "../../custom-cart-shared/custom-cart-shared.module";
import { CustomAddedToCartDialogComponent } from './custom-added-to-cart-dialog.component';
import { customAddedToCartLayoutConfig } from './custom-added-to-cart-layout.config';

@NgModule({
  declarations: [CustomAddedToCartDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CustomCartSharedModule,
    RouterModule,
    SpinnerModule,
    PromotionsModule,
    FeaturesConfigModule,
    UrlModule,
    IconModule,
    I18nModule,
    ItemCounterModule,
    KeyboardFocusModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AddedToCartDialogComponent: {
          component: CustomAddedToCartDialogComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [provideDefaultConfig(customAddedToCartLayoutConfig)],
})
export class CustomAddedToCartDialogModule { }
